// An unreadable token counts as valid; the API's 401 decides.
export const isTokenExpired = (token, now = Date.now()) => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(globalThis.atob(payload));
    return typeof exp === 'number' && exp * 1000 <= now;
  } catch {
    return false;
  }
};
